/* Selección MAS — scripts propios. Se carga una vez desde layout/theme.liquid. */
(function () {
  if (window.__smInit) return;
  window.__smInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (un solo observer) ---------- */
  var observer = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.sm-reveal:not(.sm-visible)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('sm-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('sm-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Collage del héroe: se mueve con el ratón ---------- */
  function initCollage(root) {
    (root || document).querySelectorAll('[data-sm-collage]').forEach(function (box) {
      if (box.dataset.smInit) return; box.dataset.smInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var fuerza = parseFloat(box.dataset.smFuerza || '14');
      var items = box.querySelectorAll('.sm-collage__item');
      var zona = box.closest('.sm-hero') || box;
      zona.addEventListener('mousemove', function (ev) {
        var r = zona.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        items.forEach(function (it, i) {
          var f = fuerza * (i + 1) / items.length;
          it.style.transform = 'translate3d(' + (x * f) + 'px,' + (y * f) + 'px,0)';
        });
      });
      zona.addEventListener('mouseleave', function () {
        items.forEach(function (it) { it.style.transform = ''; });
      });
    });
  }

  /* ---------- Manifiesto: palabras que se encienden con el scroll ---------- */
  var manifiestos = [];
  function initManifiesto(root) {
    (root || document).querySelectorAll('[data-sm-manif]').forEach(function (el) {
      if (el.dataset.smInit) return; el.dataset.smInit = '1';
      var pals = el.querySelectorAll('.sm-pal');
      if (reduce) { pals.forEach(function (p) { p.classList.add('sm-on'); }); return; }
      manifiestos.push({ el: el, pals: pals });
    });
    pintarManifiestos();
  }
  var ticking = false;
  function pintarManifiestos() {
    manifiestos.forEach(function (m) {
      if (!document.body.contains(m.el)) return;
      var r = m.el.getBoundingClientRect();
      var vh = window.innerHeight;
      var inicio = vh * 0.85, fin = vh * 0.35;
      var prog = (inicio - r.top) / (inicio - fin + r.height * 0.6);
      prog = Math.max(0, Math.min(1, prog));
      var n = Math.round(prog * m.pals.length);
      m.pals.forEach(function (p, i) { p.classList.toggle('sm-on', i < n); });
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking && manifiestos.length) { ticking = true; requestAnimationFrame(pintarManifiestos); }
  }, { passive: true });

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('.sm-faq__pregunta').forEach(function (btn) {
      if (btn.dataset.smInit) return; btn.dataset.smInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.sm-faq__item');
        var abierto = item.classList.toggle('sm-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* ---------- Fechas de entrega estimadas (días laborables) ---------- */
  function sumarLaborables(fecha, dias) {
    var d = new Date(fecha.getTime());
    var sumados = 0;
    while (sumados < dias) {
      d.setDate(d.getDate() + 1);
      var dia = d.getDay();
      if (dia !== 0 && dia !== 6) sumados++;
    }
    return d;
  }
  function initEnvio(root) {
    (root || document).querySelectorAll('[data-sm-envio]').forEach(function (el) {
      if (el.dataset.smInit) return; el.dataset.smInit = '1';
      var min = parseInt(el.dataset.min || '10', 10);
      var max = parseInt(el.dataset.max || '15', 10);
      var hoy = new Date();
      var opts = { day: 'numeric', month: 'long' };
      var fmt = function (d) { return d.toLocaleDateString('es-ES', opts); };
      var a = el.querySelector('[data-sm-desde]');
      var b = el.querySelector('[data-sm-hasta]');
      if (a) a.textContent = fmt(sumarLaborables(hoy, min));
      if (b) b.textContent = fmt(sumarLaborables(hoy, max));
    });
  }

  /* ---------- Copiar código de descuento ---------- */
  function initCodigo(root) {
    (root || document).querySelectorAll('[data-sm-copiar]').forEach(function (btn) {
      if (btn.dataset.smInit) return; btn.dataset.smInit = '1';
      var original = btn.textContent;
      btn.addEventListener('click', function () {
        var codigo = btn.getAttribute('data-sm-copiar');
        var ok = function () { btn.textContent = btn.dataset.copiado || 'Copiado'; setTimeout(function () { btn.textContent = original; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(ok, ok);
        } else {
          var ta = document.createElement('textarea'); ta.value = codigo; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta); ok();
        }
      });
    });
  }

  function initTodo(ev) {
    var root = ev && ev.target && ev.target.querySelectorAll ? ev.target : document;
    initReveals(root); initCollage(root); initManifiesto(root); initFaq(root); initEnvio(root); initCodigo(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
